// src/context/EditingContext.js
import React, { createContext, useState } from 'react';

export const EditingContext = createContext();

export const EditingProvider = ({ children }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [forRealEditing, setForRealEditing] = useState(false);

  return (
    <EditingContext.Provider value={{ isEditing, setIsEditing, forRealEditing, setForRealEditing }}>
      {children}
    </EditingContext.Provider>
  );
};